var React = require('react');

function JIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5 21C16.299 21 21 16.299 21 10.5S16.299 0 10.5 0 0 4.701 0 10.5 4.701 21 10.5 21z","fill":"#dc458b","key":0}),React.createElement("g",{"transform":"translate(6.7383 3.5918)","dominantBaseline":"text-before-edge","fill":"#fff","aria-label":"J","key":1},React.createElement("path",{"d":"m7.2031 7.6308q0 4.9766-4.8359 4.9766-0.39062 0-0.9375-0.09375t-1.1094-0.28125v-3.1172q0.39844 0.27344 0.88281 0.44531 0.49219 0.16406 0.8125 0.16406 0.90625 0 1.3516-0.55469 0.45312-0.5625 0.45312-1.7344v-6.2266h3.3828z"}))]);
}

JIconInline.defaultProps = {"width":"21","height":"21","version":"1.1","viewBox":"0 0 21 21"};

module.exports = JIconInline;

JIconInline.default = JIconInline;
